import React, { useEffect } from 'react';
import { View, ScrollView, Image } from 'react-native';
import { Card, Paragraph, Title } from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';

import styles from './styles';
import { AppHeader } from '../../../components/common';
import { AppButton } from '../../../components/form';
import { getPlans } from '../../../redux/actions/companyActions';
import { CompanyActions } from '../../../redux/reducers/companyReducer';
import PriceBlock from '../../../components/common/PriceBlock';

export default function PlanGymnasticLive({ navigation }) {
  const dispatch = useDispatch();
  const { companySignUp, availablePlans } = useSelector((state) => state.company);
  useEffect(() => {
    dispatch(getPlans());
  }, []);
  const handleSelectPlan = (id_plano) => {
    dispatch({ type: CompanyActions.UPDATE_SIGNUP, companySignUp: { ...companySignUp, id_plano } });
    navigation.navigate('Checkout: Selecione a data - Live');
  };
  return (
    <>
      <AppHeader navigation={navigation} hasBack title="Planos Corporativos" />
      <View style={styles.viewBase}>
        <ScrollView style={styles.baseScroll}>
          {
            availablePlans.length > 0
            && availablePlans.map((plan) => {
              if (plan.qtd_aulas_mes % 4 !== 0) {
                return null;
              }
              return (

                <Card style={styles.baseCard} key={`plan-${plan.id_plano}`}>
                  {plan.imagem && (
                    <Image
                      source={plan.imagem}
                      style={styles.imagePlan}
                    />
                  )}
                  <Card.Content style={styles.cardContent}>

                    <View style={styles.cardTitle}>

                      <Title style={styles.cardTitleText}>{plan.plano}</Title>
                      <PriceBlock price={plan.valor} perHour />
                    </View>
                    <View style={styles.cardBody}>
                      <Paragraph style={styles.paragraphTitle}>{plan.subtitulo}</Paragraph>
                      {!plan.aula_gravada && (<Paragraph>{`${plan.qtd_aulas_mes} Aulas no Mês`}</Paragraph>)}
                      <Paragraph>{`Plano - ${plan.duracao_aula} Minutos/Dia`}</Paragraph>
                      <Paragraph style={styles.cardTitleText}>{plan.descricao}</Paragraph>
                    </View>

                  </Card.Content>
                  <AppButton label="COMPRAR" labelStyle={styles.textButton} style={styles.cardButton} onPress={() => handleSelectPlan(plan.id_plano)} />
                </Card>

              );
            })
          }
        </ScrollView>
      </View>
    </>
  );
}
